



























import Vue from 'vue'

export default Vue.extend({
  computed: {
    activeTab: {
      get (): string {
        return this.$route.name!
      },
      set () {

      }
    }
  },
  async beforeRouteEnter (to, from, next) {
    try {
      next()
    } catch (error) {
      next('notFound')
    }
  }
})
